var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5L5.0125 19.9875C5.0055 21.097 5.903 22 7.0125 22H17.0535C18.137 22 19.0235 21.137 19.053 20.054L19 6.5H19.5C20.052 6.5 20.5 6.0525 20.5 5.5V4.5C20.5 3.9475 20.052 3.5 19.5 3.5H14.5V2.5C14.5 1.6715 13.8285 1 13 1H11C10.1715 1 9.5 1.6715 9.5 2.5V3.5H4.5C3.948 3.5 3.5 3.9475 3.5 4.5V5.5C3.5 6.0525 3.948 6.5 4.5 6.5H16.5M12 10.5V19M15.5 10.5V19M8.5 10.5V19",
    stroke: "#85909F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.16d51901f0f6bde4e92a3d4645510933.svg";
export { ForwardRef as ReactComponent };